import {UIGameManager} from '../../../../shared/scripts/ui_game/UIGameManager'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {UIGamePlayerInformationView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationView'
import {UIMGamePlayerCardsExchangeView} from './UIMGamePlayerCardsExchangeView'
import {UIGameConstants} from '../../../../shared/scripts/ui_game/UIGameConstants'
import {UIGameCardWithRatioContainerView} from '../../../../shared/scripts/ui_game/ui_game_card/UIGameCardWithRatioContainerView'
import {CardView} from '../../../../shared/scripts/ui_canvas_engine/CardView'
import {UIMGamePlayerCardsAnimationQueueController} from './UIMGamePlayerCardsAnimationQueueController'
import {SectionBgView} from '../../../../shared/scripts/ui_canvas_engine/SectionBgView'
import {Point} from '@colonist/game-mechanic-validators'
import {CardEnum, PlayerColor} from '@colonist/game-states'

export class UIMGamePlayerCardsAnimationController {
    private readonly uiGameManager: UIGameManager
    private readonly cardContainerView: UIGameCardWithRatioContainerView
    private readonly animationQueue: UIMGamePlayerCardsAnimationQueueController
    private readonly container: SectionBgView
    private readonly playerColor: PlayerColor
    private readonly isMyPlayer: boolean = false

    private stopOverPoint: Point

    private width: number
    private height: number

    constructor(uiGameManager: UIGameManager, container: SectionBgView, playerColor: PlayerColor, cardContainerView: UIGameCardWithRatioContainerView) {
        this.uiGameManager = uiGameManager
        this.container = container
        this.playerColor = playerColor
        this.cardContainerView = cardContainerView
        this.isMyPlayer = playerColor === this.uiGameManager.gameController.myColor
        this.animationQueue = new UIMGamePlayerCardsAnimationQueueController()

        this.initializeCardExchangeView()
        this.initializeStopOverPointForAnimation()
    }

    private initializeStopOverPointForAnimation() {
        const playerInformationView = this.uiGameManager.playersController.getPlayerInformationViewWithColor(this.playerColor)
        if(playerInformationView == undefined) return
        if(UIUtilsEjsVariables.isUserOnTabletApp) return this.initializeStopOverPositionForTablet(playerInformationView)
        return this.initializeStopOverPositionForMobile(playerInformationView)
    }

    private initializeStopOverPositionForTablet(playerInformationView: UIGamePlayerInformationView) {
        const {x: globalX, y: globalY} = playerInformationView.position
        const itemSize = this.uiGameManager.canvasController.itemSize
        const x = globalX
        const y = globalY - itemSize * 0.4
        this.stopOverPoint = new Point(x, y)
    }

    private initializeStopOverPositionForMobile(playerInformationView: UIGamePlayerInformationView) {
        const {x: playerAvatarX} = playerInformationView.playerAvatar.position
        const {x: globalX, y: globalY} = playerInformationView.position
        const itemSize = this.uiGameManager.canvasController.itemSize
        const x = globalX + playerAvatarX - this.width * 0.32
        const y = globalY - itemSize * 0.25
        this.stopOverPoint = new Point(x, y)
    }

    private initializeCardExchangeView() {
        const itemSize = this.uiGameManager.canvasController.itemSize
        const height = 0.4 * itemSize * UIGameConstants.CARD_RATIO
        this.height = height
        this.width = UIUtilsEjsVariables.isUserOnTabletApp ? itemSize * 1.3 : this.uiGameManager.canvasController.appW / 3
    }

    animateCardExchange(receivingCards: CardEnum[], givingCards: CardEnum[]) {
        if(givingCards.length == 0 && receivingCards.length == 0) return

        const animationCallback = () => {
            this.animationQueue.currentAnimationIsFinished()
        }

        const beforeAnimationStarts = () => {
            new UIMGamePlayerCardsExchangeView(this.stopOverPoint.x,
                this.stopOverPoint.y,
                this.width,
                this.height,
                this.uiGameManager.playersController.opponentsScrollbox.content,
                this.uiGameManager,
                receivingCards,
                givingCards,
                animationCallback)
            if(!this.isMyPlayer) return
            this.addCardsToHand(receivingCards)
            this.removeCardsFromHand(givingCards)
        }

        this.animationQueue.addAnimationToQueue(beforeAnimationStarts)
    }

    discardCards(cards: CardEnum[]) {
        const beforeAnimationStarts = () => {
            if(this.isMyPlayer) this.removeCardsFromHand(cards)
            this.animationQueue.currentAnimationIsFinished()
        }
        this.animationQueue.addAnimationToQueue(beforeAnimationStarts)
    }

    private addCardsToHand(cards: CardEnum[]) {
        const newCardViews = this.cardContainerView.addMultipleCards(cards)
        newCardViews.forEach((card: CardView) => card.activateInventoryCard())
    }

    private removeCardsFromHand(cards: CardEnum[]) {
        cards.forEach((card: CardEnum) => this.cardContainerView.removeCard(card))
    }
}
